require('slick-carousel');

var sliders = {
	
	init: function() {
		$('.js-slider').on('init', function() {
			// function to run when slider is initialised
		}).slick({
			rows: 0,
			dots: true
		});

		$('.js-banner-slider').each(function() {
			var $slider = $(this);
			var settings = {
				rows: 0,
				arrows: false,
				dots: true,
				slidesToShow: 1,
				fade : true,
				autoplay: true,
				autoplaySpeed: 7000,
				speed : 700,
			};
			$(this).slick(settings);
		});

		$('.js-team-member-slider').each(function() {
			var $slider = $(this);
			var settings = {
				rows: 0,
				slidesToShow: 4,
				arrows: true,
				dots: false,
				fade : false,
				autoplay: false,
				mobileFirst: false,
				prevArrow: $(this).siblings('.js-team-member-slider-prev'),
				nextArrow: $(this).siblings('.js-team-member-slider-next'),
				responsive: [
					{
						breakpoint: 1400,
						settings: {
							slidesToShow: 3,
						}
					},
					{
						breakpoint: 1100,
						settings: {
							slidesToShow: 2,
						}
					},
					{
						breakpoint: 600,
						settings: {
							slidesToShow: 1,
							dots: true,
							arrows: false,
						}
					}
				]
			};
			$(this).slick(settings);
		});
	}

};

module.exports = sliders;